__webpack_require__.p = "//s.vipkidstatic.com/fe-static/parent/ratel-new/";